export default __webpack_public_path__ + "static/hero-64db1e30d124c89b85f86ff2fea43fff.webp";